export default "__VITE_ASSET__CMoh1ZmN__"